module.exports = __webpack_public_path__ + "img/ip_page-input_bg.86170ee9.png";